'use client';

import type {BundleFooterProps as Props} from './typings';

import ProductSummaryText from './ProductSummaryText';
import {StyledProductBundleFooter, StyledProductBundleParagraph} from './styles';

const BundleFooter = ({mainProduct, bundleProduct}: Props): JSX.Element => (
  <StyledProductBundleFooter>
    <StyledProductBundleParagraph aria-label="Main product summary">
      <ProductSummaryText
        categoryName={mainProduct.category}
        artistName={mainProduct.artist}
        price={mainProduct.price as string}
      />
    </StyledProductBundleParagraph>

    <StyledProductBundleParagraph aria-label="Bundle product summary">
      <ProductSummaryText
        categoryName={bundleProduct.category}
        artistName={bundleProduct.artist}
        price={bundleProduct.price as string}
      />
    </StyledProductBundleParagraph>
  </StyledProductBundleFooter>
);

export default BundleFooter;
